import React, { Component } from "react";
import moment from "moment";
import underscore from "underscore";
import {
  Row,
  Col,
  Input,
  Radio,
  Button,
  Modal,
  Select,
  Form,
  Table,
  Pagination,
  DatePicker,
  Icon,
  Spin,
} from "antd";
import { api, app } from "../../app";
import TeamSeleted from "../../components/TeamSeleted";
import PlayerAdd from "./PlayerAdd";
import utils from "../../utils";
import Highlighter from "react-highlight-words";
import { isDom } from "echarts-gl";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;

function getIdentityList(tj) {
  const identityList = [
    { val: "1", text: "队员" },
    // { val: "2", text: "预备队员" },
    // { val: "3", text: "认证志愿者" },
    // { val: "6", text: "志愿者" },
    { val: "4", text: "离队" },
    { val: "5", text: "清退" },
  ];
  if (tj) {
    return (underscore.find(identityList, (iden) => iden.text === tj) || {})
      .val;
  }
  return identityList;
}

class ProTeamManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search_name: "vname", // 搜索名称(vname,bsrno)
      search_value: "", // 搜索值
      page: 1, // 分页
      ahegp: 20, // 默认20条一页
      team_loading: true,
      rights: app.getData("rights"),
      rights_duizhang: app.getData("rights_duizhang"),
      all_team: [],
      playerList: [],
      select_team: {},
      edit_modal: false,
      data_loading: true,
      load_index: 0,
      edit_index: -1,
      authorityList: [],
      posttionList: [],
      searchText: "",
    };
  }

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  /**
   * 权限数据
   * @returns {Promise<any>}
   */
  authorityData = async (page) => {
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg, total } = await app.post(api.RightsList, params);
    if (flag === 1) {
      await this.setData({ authorityList: data });
    } else {
      app.alert(msg, "error");
    }
  };

  authorityData2 = async () => {
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
      team_id: this.state.select_team.team_id,
    };
    let { flag, data, msg, total } = await app.post(api.RightsList, params);
    // if (data.length > 0) {
    //     data.forEach((e, k) => {
    //         if (e.multeamright_name === null) {
    //             e.multeamright_name = e.rights;
    //         }
    //     })
    // }
    if (flag === 1) {
      // console.log(data);
      await this.setData({ authorityList: data });
    } else {
      app.alert(msg, "error");
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.PosttionData();
    const innerHeight = document.body.offsetHeight,
      table_height = innerHeight - (78 + 60 + 36 + 60 + 58);
    await this.setData({ table_height });
    window.addEventListener("resize", this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
    this._isMounted = false;
  }

  /**
   * 人员列表
   */
  teamListData = async (select_team, load_index,teamList,page) => {
    await this.setData({ load_index, select_team, data_loading: true });
    if(page){
      this.setState({ page: page });
    }
    const params = {
      team_id: select_team.team_id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
      limit: this.state.ahegp || 20,
      page: this.state.page || 1,
      search_name: this.state.search_name, // 搜索名称(vname,bsrno)
      search_value: this.state.search_value, // 搜索值
    };
    let { flag, data, msg, total } = await app.post(api.GetTeamAllUser, params);
    if (flag === 1) {
      data.forEach((item) => {
        item.tpList = item.teampositionname
          ? item.teampositionname.split(",")
          : [];
      });
    } else {
      data = [];
      app.alert(msg, "error");
    }
    const state = { total, playerList: utils.addArrayKey(data || []) };
    if (this.state.load_index === load_index) {
      state.data_loading = false;
    }
    await this.setData(state);
  };

  /**
   * 显示添加对话框
   * @param add_modal
   */
  handleOpenAddModal = async (id) => {
    await this.authorityData2();
    setTimeout(() => {
      const { playerList } = this.state,
        index = playerList.findIndex((p) => p.volunteer_id === id);
      this.setData({ edit_index: index, edit_modal: true });
    }, 500);
  };

  /**
   * 隐藏添加对话框
   * @param add_modal
   */
  handleCloseAddModal = async () => {
    await this.setData({ edit_modal: false });
    this.setState({ isDo: '' });
    this.props.form.resetFields();
  };

  /**
   * 职务列表
   **/
  PosttionData = async () => {
    let { flag, data, msg } = await app.post(api.PosttionList);
    if (flag === 1) {
      const rights = app.getData("rights");
      // console.log(rights);
      let posttionList = data;
      if (rights === 1) {
        posttionList.forEach((posttion) => {
          posttion.permiss = null;
        });
      } else if (rights === 2) {
        posttionList.forEach((posttion) => {
          if (posttion.permiss === "province") {
            posttion.permiss = null;
          }
        });
      }
      await this.setData({ posttionList });
    } else {
      app.alert(msg, "error");
    }
    await this.authorityData();
  };

  /**
   * 提交
   * @param e
   */
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { select_team } = this.state,
          params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            team_id: select_team.team_id,
          };
        values.multeamright_id = values.multeamright_id
          ? values.multeamright_id.join(",")
          : "";
        values.team_position_id = values.team_position_id
          ? values.team_position_id.join(",")
          : "";
        if (values.indate) values.indate = values.indate.format("YYYY-MM-DD");
        values = Object.assign(values, params);
        const { flag, msg } = await app.post(api.UserInfoAlter, values);
        if (flag === 1) {
          this.teamListData(select_team, this.state.load_index);
          this.handleCloseAddModal();
          app.alert("修改成功", "success");
        } else {
          app.alert(msg, "error");
        }
        await this.setData({ edit_loading: false });
      }
    });
  };

  onWindowResize = (e) => {
    const { innerHeight } = e.target,
      table_height = innerHeight - (78 + 60 + 36 + 60 + 58);
    this.setData({ table_height });
  };

  /**
   *
   * @constructor
   */
  OpenAddPlayerModal = () => {
    this.setData({ add_modal: true });
  };

  // 切换选项
  changeSelect = (e) => {
    // search_value
    if (e == "姓名") {
      this.setState({
        search_name: "vname",
      });
    } else {
      this.setState({
        search_name: "bsrno",
      });
    }
    // console.log(e);
  };

  // 监听输入
  inputMotify = (e) => {
    // search_value
    this.setState({
      search_value: e.target.value,
    });
    // console.log(e.target.value);
  };

  // 去搜索
  toSearchBtn = () => {
    this.setData({ page: 1 });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  CloseAddPlayerModal = async (flag) => {
    await this.setData({ add_modal: false, add_flush: true });
    await this.setData({ add_flush: false });
    if (flag) {
      const { select_team, load_index } = this.state;
      await this.teamListData(select_team, load_index);
    }
  };

  /**
   * 表格搜索
   * @param dataIndex
   * @returns {{filterDropdown: (function({setSelectedKeys: *, selectedKeys?: *, confirm?: *, clearFilters?: *}): *), filterIcon: (function(*): *), onFilter: (function(*, *): boolean), onFilterDropdownVisibleChange: onFilterDropdownVisibleChange, render: (function(*): *)}}
   */
  getColumnSearchProps = (dataIndex, search_name) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`搜索 ${search_name}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleTableSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          onClick={() => this.handleTableReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          重置
        </Button>
        <Button
          type="primary"
          onClick={() => this.handleTableSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginLeft: 8 }}
        >
          搜索
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <Icon type="search" style={{ color: "#fff" }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  });

  /**
   * 列表搜索
   * @param selectedKeys
   * @param confirm
   */
  handleTableSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  /**
   * 列表搜索重置
   * @param clearFilters
   */
  handleTableReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // 改变页码
  changeAhegp = (q, r) => {
    this.setState({ ahegp: r, page: q });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  // 改变页码
  changeAhegp2 = (q) => {
    this.setState({ page: q });
    const { select_team, load_index } = this.state;
    this.teamListData(select_team, load_index);
  };

  handlePositionChange = (e) =>{
    this.setState({ isDo: e });
  }

  render() {
    // console.log('10'.indexOf(this.state.rights_duizhang) + "==" + '1'.indexOf(this.state.rights));
    let {
        loading,
        data_loading,
        edit_index,
        add_modal,
        edit_modal,
        edit_loading,
        playerList,
        select_team,
        selectedValues,
        posttionList,
        isDo,
        rights,
        rights_duizhang,
        add_flush,
        total,
      } = this.state,
      columns = [
        {
          title: "序号",
          dataIndex: "xuhao",
          key: "xuhao",
          width: 50,
          fixed: "left",
          render(text, record, index) {
            return <span>{index + 1}</span>;
          },
        },
        {
          title: "存心编号",
          dataIndex: "bsrno",
          key: "bsrno",
          width: 150,
          fixed: "left",
          sorter: (a, b) =>
            (a.bsrno || "0").replace(/[^0-9]/gi, "") -
            (b.bsrno || "0").replace(/[^0-9]/gi, ""),
          ...this.getColumnSearchProps("bsrno", "存心编号"),
          // width: '8%'
        },
        {
          title: "姓名",
          dataIndex: "vname",
          key: "vname",
          fixed: "left",
          width: 120,
          ...this.getColumnSearchProps("vname", "姓名"),
          // width: '9%'
        },
        {
          title: "性别",
          dataIndex: "sex",
          key: "sex",
          width: 80,
          render(text) {
            return <span>{text || "无"}</span>;
          },
          filters: [
            { text: "男", value: "男" },
            { text: "女", value: "女" },
          ],
          filterMultiple: false,
          filterIcon: (filtered) => (
            <Icon
              type="filter"
              theme="filled"
              style={{ color: filtered ? "#bfbfbf" : "#fff" }}
            />
          ),
          onFilter: (value, record) => record.sex === value,
          // width: '5%'
        },
        {
          title: "队内职务",
          dataIndex: "teampositionname",
          key: "teampositionname",
          width: 160,
          // width: '9%',
          render(text) {
            return <span>{text || " - "}</span>;
          },
          filters: posttionList.map((p) => ({
            text: p.position_name,
            value: p.position_name,
          })),
          filterMultiple: false,
          filterIcon: (filtered) => (
            <Icon
              type="filter"
              theme="filled"
              style={{ color: filtered ? "#bfbfbf" : "#fff" }}
            />
          ),
          onFilter: (value, record) => record.tpList.indexOf(value) !== -1,
        },
        {
          title: "身份",
          dataIndex: "volunteer_state",
          key: "volunteer_state",
          width: 100,
          // width: '8%',
          filters: [
            { text: "队员", value: "队员" },
            { text: "预备队员", value: "预备队员" },
            { text: "认证志愿者", value: "认证志愿者" },
            { text: "志愿者", value: "志愿者" },
          ],
          filterMultiple: false,
          filterIcon: (filtered) => (
            <Icon
              type="filter"
              theme="filled"
              style={{ color: filtered ? "#bfbfbf" : "#fff" }}
            />
          ),
          onFilter: (value, record) => record.volunteer_state === value,
          render(text) {
            return <span>{text || " - "}</span>;
          },
        },
        {
          title: "手机号",
          dataIndex: "mobile",
          key: "mobile",
          width: 120,
          render(text) {
            return (
              <span>
                {text
                  ? app.replaceIndexStr(text, "*", 2, text.length - 2)
                  : "无"}
              </span>
            );
          },
        },
        {
          title: "身份证",
          dataIndex: "idno",
          key: "idno",
          width: 180,
          render(text) {
            return (
              <span>
                {text
                  ? app.replaceIndexStr(text, "*", 2, text.length - 2)
                  : "无"}
              </span>
            );
          },
        },
        {
          title: "护照号",
          dataIndex: "passport",
          key: "passport",
          width: 180,
          render(text) {
            return (
              <span>
                {text
                  ? app.replaceIndexStr(text, "*", 2, text.length - 2)
                  : "无"}
              </span>
            );
          },
        },
        {
          title: "入队时间",
          dataIndex: "indate",
          key: "indate",
          width: 100,
          // width: '8%',
          render(text) {
            return (
              <span>{text ? moment(text).format("YYYY-MM-DD") : "无"}</span>
            );
          },
        },
        {
          title: "权限",
          dataIndex: "rights",
          key: "rights",
          width: 250,
          // width: '8%',
          render(text) {
            return (
              <span>
                {(text || []).map((r) => r.multeamright).join("、") || "暂无"}
              </span>
            );
          },
        },
        {
          title: "操作",
          dataIndex: "caozuo",
          key: "caozuo",
          fixed: "right",
          width: 80,
          render: (text, record) => {
            return (
              <Button
                size="small"
                type="primary"
                onClick={() => this.handleOpenAddModal(record.volunteer_id)}
              >
                编辑
              </Button>
            );
          },
        },
      ],
      formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      { getFieldDecorator, getFieldValue } = this.props.form,
      table_height = this.state.table_height || 600,
      identityList = getIdentityList(),
      edit_info = playerList[edit_index] || {};
      let identity = '';
    // console.log(identity);
    if (!isDo) {
      if (edit_info.volunteer_state === "志愿者") {
        identity = 6;
      } else if (edit_info.volunteer_state === "成员") {
        identity = 1;
      } else if (edit_info.volunteer_state === "预备") {
        identity = 2;
      } else if (edit_info.volunteer_state === "认证志愿者") {
        identity = 3;
      }
    }else{
      identity = isDo
    }
    let reasonItem = null,
      bsrnoItem = null,
      notLK = true,
      { authorityList } = this.state;
    authorityList = app.objectArrayAdd(
      authorityList,
      edit_info.rights,
      (obj) => {
        if (
          authorityList.findIndex(
            (author) => author.multeamright_id === obj.id
          ) === -1
        ) {
          return {
            multeamright_id: obj.id,
            multeamright_name: obj.multeamright,
            disabled: true,
          };
        }
        return null;
      }
    );
    // console.log(this.state.authorityList);

    // this.state.authorityList.forEach((e, k) => {
    //     if (e.multeamright_name == '粤all') {
    //         console.log("有值，位置：" + k);
    //     }
    // })

    if (identity === "4" || identity === "5") {
      notLK = false;
      reasonItem = (
        <FormItem {...formItemLayout} label="身份修改原因">
          {getFieldDecorator("leave_reason", {
            rules: [
              {
                required: true,
                message: "请输入离队/清退 原因！",
              },
            ],
          })(<Input.TextArea placeholder="请填写离队/清退 原因" rows={4} />)}
        </FormItem>
      );
    }
    if (identity != "6") {
      notLK = true;
      bsrnoItem = (
        <FormItem {...formItemLayout} label="存心编号">
          {getFieldDecorator("bsrno", {
            rules: [
              { required: identity=='4'||identity=='5'?false:true, message: "请输入存心编号！" },
              { max: 6, message: "存心编号长度规定为6位!" },
            ],
            initialValue: edit_info.bsrno || "",
          })(<Input placeholder="请填写存心编号" style={{ width: 240 }} />)}
          <span className="ant-form-text">{edit_info.bsrno_audit}</span>
        </FormItem>
      );
    }
    let rights_edit;
    if (
      this.state.rights == "1" ||
      this.state.rights == "2" ||
      this.state.rights_duizhang == "10"
    ) {
      rights_edit = false;
    } else {
      rights_edit = true;
    }

    const title_box = (e) => {
      return (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItem: "center",
          }}
        >
          <div>编辑队员信息</div>
          <div style={{ fontWeight: "600" }}>{e || ""}</div>
          <div style={{ width: "100px", height: "1px" }}></div>
        </div>
      );
    };

    function showTotal(total) {
      return `总数：${total}条`;
    }

    return (
      <div className="team-editor pro-team">
        <div className="top-title">队员管理</div>
        <Row className="content">
          <Col span={5} className="team-select">
            <TeamSeleted handleData={this.teamListData} />
          </Col>
          <Col span={18} offset={1} className="team-table">
            <Table
              className="ranks_table"
              title={() => {
                return (
                  <Row className="pro-table-title">
                    <Col span={12}>{select_team.teamname || "队伍名称"}</Col>
                    <Col
                      span={12}
                      style={{
                        textAlign: "right",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Input.Group compact>
                        <Select
                          style={{ width: 100 }}
                          defaultValue="姓名"
                          onChange={(e) => this.changeSelect(e)}
                        >
                          <Option value="姓名">姓名</Option>
                          <Option value="存心编号">存心编号</Option>
                        </Select>
                        <Input.Search
                          onSearch={() => this.toSearchBtn()}
                          onChange={(e) => this.inputMotify(e)}
                          style={{ width: 240, marginRight: 32 }}
                          enterButton="搜索"
                        />
                      </Input.Group>
                      <Button
                        type="primary"
                        onClick={() => this.OpenAddPlayerModal()}
                      >
                        添加队员
                      </Button>
                    </Col>
                  </Row>
                );
              }}
              locale={app.tbLocale(loading)}
              columns={columns}
              dataSource={playerList}
              loading={data_loading}
              scroll={{ y: table_height, x: 1570 }}
              size="small"
              pagination={false}
              // pagination={{

              // }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Pagination
                style={{ marginTop: 16 }}
                current={this.state.page}
                defaultCurrent={1}
                total={total}
                showTotal={showTotal}
                defaultPageSize={20}
                pageSizeOptions={["20", "50", "100"]}
                showSizeChanger={true}
                size="default"
                onShowSizeChange={(e, a) => this.changeAhegp(e, a)}
                onChange={(e) => this.changeAhegp2(e)}
              />
            </div>
            <Modal
              visible={edit_modal}
              title={title_box(select_team.teamname || "队伍名称异常")}
              onCancel={this.handleCloseAddModal}
              footer={
                <Row type="flex" justify="center">
                  <Button
                    type="primary"
                    loading={edit_loading}
                    onClick={this.handleSubmit}
                  >
                    确定
                  </Button>
                </Row>
              }
              maskClosable={false}
              width={1200}
              className="edit-team-modal"
            >
              <Form>
                {getFieldDecorator("volunteer_id", {
                  initialValue: edit_info.volunteer_id,
                })(<Input type="hidden" />)}
                <FormItem {...formItemLayout} label="姓名">
                  {getFieldDecorator("name", {
                    rules: [
                      {
                        required: true,
                        message: "请输入队员姓名！",
                      },
                    ],
                    initialValue: edit_info.vname || "",
                  })(
                    <Input
                      placeholder="请填写队员姓名"
                      disabled={edit_info.ifhasrealname === "true"}
                    />
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="身份证">
                  {getFieldDecorator("idno", {
                    rules: [{ required: true, message: "请填写身份证号！" }],
                    initialValue: edit_info.idno || "",
                  })(
                    <Input
                      placeholder="请填写身份证号"
                      max={18}
                      disabled={edit_info.ifhasrealname === "true"}
                    />
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="入队时间">
                  {getFieldDecorator("indate", {
                    rules: [{ required: notLK, message: "请选择入队时间！" }],
                    initialValue:
                      edit_info.indate && edit_info.indate !== "0000-00-00"
                        ? moment(edit_info.indate)
                        : null,
                  })(
                    <DatePicker
                      placeholder="请选择入队时间"
                      format="YYYY年MM月DD日"
                      style={{ width: 240 }}
                    />
                  )}
                </FormItem>
                {bsrnoItem}
                <FormItem {...formItemLayout} label="队内职务">
                  {getFieldDecorator("team_position_id", {
                    rules: [
                      {
                        required: notLK,
                        message: "请选择队员队内职务！",
                      },
                    ],
                    initialValue: edit_info.teampositionname
                      ? edit_info.teampositionname.split(",").map((p) => {
                          const posi = underscore.find(
                            posttionList,
                            (obj) => obj.position_name === p
                          );
                          return posi.position_id;
                        })
                      : [],
                  })(
                    <Select
                      mode="multiple"
                      placeholder="请选择队员队内职务"
                      notFoundContent="无"
                      style={{ width: 240 }}
                      optionFilterProp="children"
                      allowCle
                    >
                      {posttionList.map((posttion, index) => {
                        return (
                          <Option
                            key={index + 1}
                            value={posttion.position_id}
                            disabled={posttion.permiss !== null}
                          >
                            {posttion.position_name}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                  <span className="ant-form-text">
                    {edit_info.teamposition_audit}
                  </span>
                </FormItem>
                <FormItem {...formItemLayout} label="身份">
                  {getFieldDecorator("identity", {
                    rules: [
                      {
                        required: true,
                        message: "请选择队员身份！",
                      },
                    ],
                    initialValue: edit_info.volunteer_state
                      ? getIdentityList(edit_info.volunteer_state.trim())
                      : "",
                  })(
                    <Select placeholder="请选择队员身份"  onChange={(e) => this.handlePositionChange(e)} style={{ width: 240 }}>
                      {identityList.map((iden, index) => {
                        return (
                          <Option key={index + 1} value={iden.val}>
                            {iden.text}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                  <span className="ant-form-text">
                    {edit_info.volunteer_state_audit}
                  </span>
                </FormItem>
                {reasonItem}
                {/*<p*/}
                {/*  style={{*/}
                {/*    color: "red",*/}
                {/*    lineHeight: 2,*/}
                {/*    width: "51%",*/}
                {/*    margin: "0 auto",*/}
                {/*  }}*/}
                {/*>*/}
                {/* 【 志愿者 】身份不对外公开查询；【志愿者】不设存心编号*/}
                {/*</p>*/}
                <FormItem {...formItemLayout} label="手机号">
                  {getFieldDecorator("mobile", {
                    rules: [
                      {
                        required: true,
                        message: "请填写队员手机号！",
                      },
                    ],
                    initialValue: edit_info.mobile || "",
                  })(<Input placeholder="请填写队员手机号" />)}
                </FormItem>
                <FormItem {...formItemLayout} label="管理权限">
                  {getFieldDecorator("multeamright_id", {
                    initialValue:
                      edit_info.rights && edit_info.rights.length > 0
                        ? edit_info.rights.map((r) => r.id)
                        : [],
                  })(
                    <Select
                      mode="multiple"
                      placeholder={
                        rights_edit ? "您不可以编辑权限" : "请选择队员权限"
                      }
                      optionFilterProp="children"
                      notFoundContent="无"
                      disabled={rights_edit}
                    >
                      {authorityList.map((authority, index) => {
                        return (
                          <Option
                            key={index + 1}
                            disabled={authority.disabled}
                            value={authority.multeamright_id}
                          >
                            {authority.multeamright_name}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="护照号">
                  {getFieldDecorator("passport", {
                    initialValue: edit_info.passport || "",
                  })(<Input placeholder="护照号" />)}
                </FormItem>
                <FormItem {...formItemLayout} label="性别">
                  {getFieldDecorator("sex", {
                    initialValue: edit_info.sex || "",
                  })(
                    <RadioGroup
                      options={[
                        { label: "男", value: "男" },
                        { label: "女", value: "女" },
                      ]}
                    />
                  )}
                </FormItem>
                <div className="zhu">
                  注：队员清退后，整个存心系统不再录用。队员清退或离队后，信息（包括个人信息、参与救援经历、清退/离队原因等）仍可被搜索查看。
                  <br /> 管理权限（队管理员）由各队队长自行分配。
                </div>
              </Form>
            </Modal>
            <Modal
              visible={add_modal}
              title={(select_team.teamname || "队伍名称") + "（添加队员）"}
              onCancel={this.CloseAddPlayerModal}
              footer={null}
              width={800}
              maskClosable={false}
              className="edit-team-modal"
            >
              <PlayerAdd
                flush={add_flush}
                select_team={select_team}
                close={this.CloseAddPlayerModal}
              />
            </Modal>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Form.create()(ProTeamManage);



// WEBPACK FOOTER //
// ./src/routes/ranks/ProTeamManage.jsx